import { CommonModule, NgOptimizedImage } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { IndustryComponentsModule } from '../pages/industries/components/industry-components.module';
import { AboutHomeComponent } from './components/components/about-home.component';
import { IntroHeaderComponent } from './components/components/intro-header.component';
import { OurTechComponent } from './components/components/new-out-tect.component';
import { SolutionsContainerComponent } from './components/components/solutions-section.component';
import { CarouselIconsComponent } from './components/components/techIcons.component';
import { TechnologySectionComponent } from './components/components/technology-section.component';
import { CookiesNoticeComponent } from './components/cookies-notice/cookies-notice.component';
import { ScrollToTopComponent } from './components/scroll-to-top/scroll-to-top.component';
import { SliderModule } from './components/sliders/slider.module';
import { NavbarComponent } from './navbar/navbar.component';
import { CarouselComponent } from './ui-components/carousel/carousel.component';
import { HeaderNavComponent } from './ui-components/header-nav/header-nav.component';
import { NavDropdownComponent } from './ui-components/nav-dropdown/nav-dropdown.component';
import { NavModule } from './ui-components/navs/nav.module';
import { UiComponentsModule } from './ui-components/ui-components.module';
import { Routes } from './utils/router';
@NgModule({
  declarations: [
    NavbarComponent,
    CarouselComponent,
    ScrollToTopComponent,
    NavDropdownComponent,
    HeaderNavComponent,
    CookiesNoticeComponent,
    IntroHeaderComponent,
    AboutHomeComponent,
    TechnologySectionComponent,
    SolutionsContainerComponent,
    OurTechComponent,
    CarouselIconsComponent,

  ],
  imports: [
    // BrowserModule,
    CommonModule,
    RouterModule,
    CarouselModule ,
    BrowserAnimationsModule,
    SliderModule,
    IndustryComponentsModule,
    NgOptimizedImage,
    NavModule,
    UiComponentsModule,
  ],
  exports: [
    NavbarComponent,
    ScrollToTopComponent,
    HeaderNavComponent,
    CarouselComponent,
    CookiesNoticeComponent,
    IntroHeaderComponent,
    AboutHomeComponent,
    TechnologySectionComponent,
    SolutionsContainerComponent,
    OurTechComponent,
    UiComponentsModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ],
  providers:[Routes,CookieService]
})
export class SharedModule { }
